// extracted by mini-css-extract-plugin
export default {"title":"RyOb4","content":"RAn7V"};